// Copyright (c) Move Closer 2022.

import { ModalPayload } from '../../../shared/organisms/AbstractModal'

import { CartModel } from '../../contracts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl> (edited)
 */
export interface InPostModalPayload extends ModalPayload {
  cart: CartModel
  onSelection (parcel: InPostParcel): void
  selected?: string
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl> (edited)
 */
export enum InPostModalTab {
  Map = 'map',
  List = 'list'
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
/* eslint-disable camelcase */
export interface InPostParcel {
  address: { line1: string; line2: string}
  address_details: {
    building_number: string
    city: string
    flat_number: string | null
    province: string
    post_code: string
    street: string
  }
  agency: string
  distance: number
  easy_access_zone: boolean
  functions: string[]
  href: string
  image_url: string
  is_next: boolean
  location: {
    latitude: string
    longitude: string
  }
  location_247: boolean
  location_description: string
  location_type: string
  name: string
  opening_hours: string
  partner_id: number
  payment_available: boolean
  payment_point_descr: string
  payment_type: Record<number, string>
  phone_number: string
  physical_type_description: string
  physical_type_mapped: string
  status: string
  type: string[]
  virtual: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
}
